import { render, staticRenderFns } from "./SetBirthday.vue?vue&type=template&id=59146e4e&scoped=true&lang=pug"
import script from "./SetBirthday.vue?vue&type=script&lang=js"
export * from "./SetBirthday.vue?vue&type=script&lang=js"
import style0 from "./SetBirthday.vue?vue&type=style&index=0&id=59146e4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59146e4e",
  null
  
)

export default component.exports